import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { GetTagsForManualContentResponse } from '../_types/awb';

export const getAccreditationTags = async (manualId: string, contentId: string) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/manuals/${manualId}/content/${contentId}/tags`;
  const data = await fetcher({
    method: 'get',
    url,
  });
  return data;
};

export default function useAccreditationTags(
  manualId?: string,
  contentId?: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<GetTagsForManualContentResponse, ServerErrorResponse>(
    ['accreditation_tags', manualId, contentId],
    async () => {
      try {
        const data = await getAccreditationTags(manualId || '', contentId || '');
        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      ...options,
      enabled: !!manualId && !!contentId,
      keepPreviousData: false,
      refetchOnWindowFocus: true,
      refetchInterval: 1000 * 60 * 5, // 5 minutes
    }
  );
}
